import React, { useRef, useState } from 'react';
import { GiWheat, GiThreeLeaves, GiPlantSeed, GiPlantRoots } from 'react-icons/gi';
import { FaLeaf } from 'react-icons/fa';
import { FiMapPin, FiPhone, FiMail, FiRotateCcw } from 'react-icons/fi';
import Reveal from '../Reveal/Reveal';
import { CONTACT } from '../../data/content';
import '../../styles/video.css';

/* Upload your farm video to public/ and set the filename here. */
const VIDEO_SRC = `${process.env.PUBLIC_URL}/mahizh-video.mp4`;
const POSTER = `${process.env.PUBLIC_URL}/about/caro1.jpg`;

/* Faint decorative nature watermarks scattered in the background */
const DECOR = [
  { Icon: FaLeaf, cls: 'd1' },
  { Icon: GiWheat, cls: 'd2' },
  { Icon: GiThreeLeaves, cls: 'd3' },
  { Icon: GiPlantSeed, cls: 'd4' },
  { Icon: GiPlantRoots, cls: 'd5' },
  { Icon: GiWheat, cls: 'd6' },
  { Icon: GiThreeLeaves, cls: 'd7' },
];

export default function VideoShowcase() {
  const videoRef = useRef(null);
  const [ended, setEnded] = useState(false);

  const replay = () => {
    setEnded(false);
    const v = videoRef.current;
    if (v) {
      v.currentTime = 0;
      v.play();
    }
  };

  return (
    <section className="section video-showcase">
      <div className="video-showcase__decor" aria-hidden="true">
        {DECOR.map(({ Icon, cls }) => (
          <Icon key={cls} className={`video-showcase__leaf ${cls}`} />
        ))}
      </div>

      <div className="container">
        <Reveal className="section-head">
          <h2 className="section-title">A glimpse into Mahizh Farms</h2>
          <p className="section-subtitle">
            Take a walk through our fields and see how nature and tradition come
            together in every harvest.
          </p>
        </Reveal>

        <Reveal className="video-showcase__frame">
          <span className="video-showcase__corner video-showcase__corner--tl" />
          <span className="video-showcase__corner video-showcase__corner--tr" />
          <span className="video-showcase__corner video-showcase__corner--bl" />
          <span className="video-showcase__corner video-showcase__corner--br" />
          <video
            ref={videoRef}
            className="video-showcase__player"
            controls={!ended}
            preload="metadata"
            playsInline
            poster={POSTER}
            onEnded={() => setEnded(true)}
            onPlay={() => setEnded(false)}
          >
            <source src={VIDEO_SRC} type="video/mp4" />
            Your browser does not support the video tag.
          </video>

          {/* Location card shown once the video finishes */}
          <div className={`video-showcase__end ${ended ? 'is-visible' : ''}`}>
            <div className="video-showcase__end-map">
              {ended && (
                <iframe
                  title="Mahizh Natural Farm location"
                  src={`https://www.google.com/maps?q=${CONTACT.lat},${CONTACT.lng}&z=14&output=embed`}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                />
              )}
            </div>

            <div className="video-showcase__end-info">
              <span className="video-showcase__end-brand">
                Mahizh Natural Farming
              </span>
              <ul className="video-showcase__end-details">
                <li>
                  <FiMapPin />
                  <span>{CONTACT.address}</span>
                </li>
                <li>
                  <FiPhone />
                  <span>
                    <a href={CONTACT.phoneHref}>{CONTACT.phone}</a>
                    <br />
                    <a href={CONTACT.phone2Href}>{CONTACT.phone2}</a>
                  </span>
                </li>
                <li>
                  <FiMail />
                  <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
                </li>
              </ul>
              <button
                type="button"
                className="video-showcase__replay"
                onClick={replay}
              >
                <FiRotateCcw /> Watch again
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
